module.exports = __webpack_public_path__ + "img/business_intro_2.7311c87d.jpg";